import { z } from "zod";

// NOTE (Ezra, 2026-07-30): Keep the Site Builder agent view providers aligned
// with the website-builder miniapp so the model cannot invent provider values.
export const scriptProviderSchema = z.enum([
  "GA4",
  "GoogleTagManager",
  "Meta",
  "TikTok",
  "Pinterest",
  "Reddit",
  "Snapchat",
  "Hotjar",
  "MicrosoftClarity",
  "Contentsquare",
  "Triplewhale",
  "Segment",
  "Northbeam",
  "Cookiebot",
  "Elevar",
  "Gorgias",
  "Converge",
]);

export type ScriptProvider = z.infer<typeof scriptProviderSchema>;
